import { render } from "./setTime.vue?vue&type=template&id=166725f4&scoped=true"
import script from "./setTime.vue?vue&type=script&lang=js"
export * from "./setTime.vue?vue&type=script&lang=js"

import "./setTime.vue?vue&type=style&index=0&id=166725f4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166725f4"]])

export default __exports__